export enum PaymentSource {
  Direct = '001',
  CreditCard = '002',
  AutoDebit = '003',
  StandingInstruction = '004',
  SalaryDeduction = '005',
  BPA = '006',
  InterBankFundTransfer = '008',
}
